import React from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import styled from 'styled-components';
import Box from 'components/Box';
import Text from 'components/Text';
import CurrencyInputPrecision from 'components/CurrencyInputPrecision';

type ICleaningFeeProps = {};
const CleaningFee: React.FC<ICleaningFeeProps> = () => {
  const form = Form.useFormInstance();

  const handleCashChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let cashValue = Number(e.target.value);
    if (cashValue > 100) cashValue = 100; // Limiting max value to 100
    const checkValue = 100 - cashValue;
    form.setFieldsValue({
      cleanerPercentCheck: checkValue,
    });
  };

  const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let checkValue = Number(e.target.value);
    if (checkValue > 100) checkValue = 100; // Limiting max value to 100
    const cashValue = 100 - checkValue;
    form.setFieldsValue({
      cleanerPercentCash: cashValue,
    });
  };

  return (
    <CleaningFeeStyled className='CleaningFeeStyled'>
      <Row gutter={[16, 16]}>
        <Col flex={1}>
          <Form.Item
            name='cleaningFee'
            label='Cleaning Fee Value'
            rules={[
              () => ({
                validator(_, value) {
                  if (value && isNaN(Number(value))) {
                    return Promise.reject(new Error('Cleaning Fee must be a number'));
                  }

                  if (value && Number(value) < 0) {
                    return Promise.reject(new Error('Cleaning Fee cannot be negative'));
                  }

                  return Promise.resolve();
                },
              }),
            ]}
          >
            <CurrencyInputPrecision height={'3rem'} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name='cleanerPercentCheck'
            label={
              <Box display='flex' gap='1'>
                % Check<Text color='error_6'>(*)</Text>
              </Box>
            }
            rules={[
              {
                required: true,
                message: 'Missing check',
              },
              () => ({
                validator(_, value) {
                  if (!value || (value >= 0 && value <= 100)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Check should be between 0 and 100'));
                },
              }),
            ]}
          >
            <Input type='number' onChange={handleCheckChange} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name='cleanerPercentCash'
            label={
              <Box display='flex' gap='1'>
                % Cash<Text color='error_6'>(*)</Text>
              </Box>
            }
            rules={[
              {
                required: true,
                message: 'Missing cash',
              },
              () => ({
                validator(_, value) {
                  if (!value || (value >= 0 && value <= 100)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Cash should be between 0 and 100'));
                },
              }),
            ]}
          >
            <Input type='number' onChange={handleCashChange} />
          </Form.Item>
        </Col>
      </Row>
    </CleaningFeeStyled>
  );
};

export default CleaningFee;

const CleaningFeeStyled = styled.div`
  padding: 1rem;
  background: var(--fill-fill-1, #f6f7fc);
  box-shadow:
    -1px 1px 4px 0px rgba(0, 0, 0, 0.1) inset,
    0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 1rem;
  .ant-select {
    height: 3rem;
  }
`;
